import { CrossFrameUtils, EnvironmentDetail } from '@amzn/ihm-associate-tools-js-lib'
import { generateDeferredPromise } from '@utils/DeferredPomiseUtil'
import { isCordovaAvailableListener } from '@crossframe/listeners/isCordovaAvailable'

const CORDOVA_CHECKING_RETRIES_COUNT = 40 // Updating retries to 40 i.e. 500ms * 40 = 20 seconds
const cordovaReadyPromise = generateDeferredPromise<any>()
let deviceReadyEventFired = false

document.addEventListener('deviceready', () => {
    console.debug('Received cordova deviceready event.')
    cordovaReadyPromise.resolve(null)
    deviceReadyEventFired = true
})

if (!EnvironmentDetail.isAndroid()) {
    cordovaReadyPromise.reject(null)
} else {
    // Fallback in case this object was constructed after cordova fired the event.
    pollForCordova(CORDOVA_CHECKING_RETRIES_COUNT)
}

function pollForCordova (retriesLeft) {
    if (deviceReadyEventFired) {
        return
    }
    console.info('ATBase: Checking to see if cordova is available')
    isCordovaAvailableListener().then((cordovaFound) => {
        console.info('ATBase: Cordova Found: ' + cordovaFound)
        if (cordovaFound) {
            cordovaReadyPromise.resolve(null)
        } else {
            if (retriesLeft > 0) {
                setTimeout(() => {
                    pollForCordova(retriesLeft - 1)
                }, 500)
            } else {
                cordovaReadyPromise.reject(null)
            }
        }
    })
}

/**
 * @resolved: If Cordova has initialized
 * @rejected: If Cordova has not initialized; clients must proceed accordingly.
 */
export function getCordovaReadyPromise (): Promise<any> {
    return cordovaReadyPromise.promise
}
